/*
 * Copyright (c) 2023.
 * @FileName: resCodeConst
 * @FilePath: src/constants
 * @Description:
 * @Project: kerastase_2022_member-center_wx-mp_frontend
 * @Author: lunazhou
 * @Date: 2023/2/2 19:14
 * @LastEditors: lunazhou
 * @LastEditTime: 2023/2/2 19:14
 */
export const resCode = {
  successCode: ['0', '200'],
};
